<ng-container *ngIf="app">
<div class="icon"  *ngIf="hasIcon">
  <img class="icon" [src]="getFaviconUrl(app.url)" width="18" height="18">
</div>
<div class="info">
  <div class="name">
    {{ app.name }}
  </div>
  <div class="description" *ngIf="app?.description">
    {{app.description}}
  </div>
</div>
<div class="info">
  <div class="version">
    <span>{{app.configSchemeVersion}}</span>
  </div>
</div>
</ng-container>

<ng-container *ngIf="config as config">
  <div class="info">
    <div class="name">
      {{ config.name }}
    </div>
    <div class="description" *ngIf="config.description">
      {{config.description ? config.description : ( 'pages.apps.noDescription' |  translate )}}
    </div>
  </div>
  <div class="info">
    <div class="name" *ngIf="config.published else notPublished">
      {{ 'pages.apps.form.published' | translate }}
    </div>
    <ng-template #notPublished class="description">
      {{'pages.apps.form.notPublished' | translate}}
    </ng-template>
  </div>
  <div class="info" *ngIf="config.restaurants as restaurants">
    <div
      class="description"
      *ngIf="restaurants.ids && restaurants.ids.length > 1 && !restaurants.all"
    >
      <div class="restaurants__total" [matTooltip]="tooltipText" matTooltipClass="multiline-tooltip">
        <span><b>{{restaurants.ids.length}}</b> {{ 'pages.apps.restaurants' | translate }}</span>
        <fa-icon class="fa-lg" [icon]="icons.info"></fa-icon>
      </div>
    </div>
    <div class="restaurants"
         *ngIf="restaurants.ids && restaurants.ids?.length === 1 && restaurants.ids[0] && !restaurants.all"
    >
      <span class="restaurants__solo">{{restaurantNames[restaurants.ids[0]]}}</span>
    </div>
    <div class="menu__value__restaurants" *ngIf="config?.restaurants?.all">
      {{ 'pages.apps.form.addToAllRest' | translate }}
    </div>
  </div>
</ng-container>
